(() => {
  function visible(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function findLauncher(root) {
    if (!root || !root.querySelector) return null;
    const direct = root.querySelector('.loloyal-launcher, button[data-loloyal-launcher], [data-loloyal-launcher][role="button"], [data-loloyal-launcher] button, .loloyal-launcher-box button');
    if (visible(direct)) return direct;
    for (const element of root.querySelectorAll('*')) {
      if (!element.shadowRoot) continue;
      const nested = findLauncher(element.shadowRoot);
      if (nested) return nested;
    }
    return null;
  }

  function nativeLauncher() {
    const host = document.querySelector('#loloyal-launcher-box, [data-loloyal-launcher], .loloyal-launcher-box');
    if (!host) return null;
    return findLauncher(host.shadowRoot || host) || host.querySelector('button, [role="button"], a');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pb-rewards-trigger]');
    if (!trigger) return;
    event.preventDefault();
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    let attempts = 0;

    const tryOpen = () => {
      const launcher = nativeLauncher();
      if (launcher) {
        launcher.click();
        trigger.disabled = false;
        trigger.removeAttribute('aria-busy');
        return;
      }
      attempts += 1;
      if (attempts < 20) return window.setTimeout(tryOpen, 150);
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
      window.location.assign(trigger.dataset.accountUrl || '/account/login');
    };

    tryOpen();
  });
})();
